import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccSimpleInputTextFormComponent, AccSimpleInputTextFormInterface } from '../acc-simple-input-text-form.component';

@Injectable({
  providedIn: 'root'
})
export class AccSimpleInputTextFormService {

  constructor(
    private dialog: MatDialog,
  ) { }

  public open(data: AccSimpleInputTextFormInterface, disableClose: boolean = false, others?: any | null) {
    return this.dialog.open(AccSimpleInputTextFormComponent, { data, disableClose, ...others });
  }
}
